import React from "react";
import "./resume.css";   // ⬅️ Asegúrate de importar la hoja de estilos

export default function Resume() {
    const resumeData = {
        education: [
          {
            institution: "Universidad de Sonora",
            period: "2012 – 2017",
            place: "Hermosillo, Sonora",
            description:
              "Egresada de la Licenciatura en Música con especialización en canto; materias de docencia vocal y participación en ensambles corales, óperas y producciones."
          }
        ],
      
        experience: [
          {
            company: "Instituto Bicultural Atwell",
            role: "Profesora de Música",
            period: "Ene 2024 – Actualidad",
            location: "Hermosillo",
            summary:
              "Clases a grupos reducidos de primaria e inclusión de niños con necesidades especiales mediante juegos, canto, solfeo e iniciación musical."
          },
          {
            company: "Academia Scherzo",
            role: "Profesora de Canto y Guitarra",
            period: "2019 – 2022",
            location: "Hermosillo",
            summary:
              "Enseñanza de teoría musical aplicable a géneros contemporáneos y música académica."
          },
          {
            company: "Independiente",
            role: "Profesora de Canto, Guitarra, Ukelele y Piano",
            period: "2016 – Actualidad",
            location: "Hermosillo / Online",
            summary:
              "Clases particulares presenciales y virtuales a estudiantes desde 5 años hasta adultos mayores.",
            highlights: [
              "Adaptación para alumnos con discapacidades",
              "Uso de plataformas de videollamada y redes sociales"
            ]
          },
          {
            company: "Independiente",
            role: "Cantante Mezzosoprano",
            period: "2011 – Actualidad",
            location: "Hermosillo",
            summary:
              "Proyecto solista, producción experimental y participación en óperas y concursos.",
            highlights: [
              "Coro en ópera “Carmen” – FAOT 2015",
              "Coro en ópera “Don Pasquale” – 2013",
              "4.º lugar concurso estatal ‘Enrólate’ – 2008"
            ]
          },
          {
            company: "Aires de Son HS",
            role: "Voz principal, cuerdas y percusión",
            period: "Abr 2017 – Actualidad",
            location: "Hermosillo / Estado de Sonora",
            summary:
              "Ensamble folclórico con múltiples presentaciones y grabaciones.",
            highlights: [
              "Festival Vale Bailar! Vale Cantar! – Magdalena de Kino 2018",
              "Fiestas del Pitic – 2019, 2021, 2022",
              "Concierto “Los Sones como Son” – Teatro Emiliana de Zubeldía 2017"
            ]
          },
          {
            company: "The Class Inc (Proyecto Musical)",
            role: "Voz principal, piano, guitarra",
            period: "Ago 2024 – Actualidad",
            location: "Hermosillo",
            summary:
              "Banda‑escuela para que alumnos vivan la experiencia de tocar en ensamble usando equipos profesionales."
          },
          {
            company: "Rondalla Don Silvestre Rodríguez",
            role: "Voz principal y guitarra",
            period: "2006 – 2012",
            location: "Nacozari de García, Sonora",
            summary:
              "Participaciones en la sierra de Sonora y 4 años consecutivos en el festival ‘Luna de Montaña’.",
            highlights: [
              "Presentación homenaje luctuoso a Don Silvestre Rodríguez (2009 – 2012)"
            ]
          }
        ]
      };
  return (
    <div className="resume-container">
      {/* ===== Formación Académica ===== */}
      <section className="section">
        <h2 className="section-title">Formación Académica</h2>
        {resumeData.education.map((item, idx) => (
          <article className="card" key={idx}>
            <header className="card-header">
              <h3 className="card-title">{item.institution}</h3>
              <span className="card-meta">
                {item.place} · {item.period}
              </span>
            </header>
            <div className="card-body">
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </section>

      {/* ===== Experiencia ===== */}
      <section className="section">
        <h2 className="section-title">Experiencia</h2>
        {resumeData.experience.map((item, idx) => (
          <article className="card" key={idx}>
            <header className="card-header">
              <h3 className="card-title">
                {item.company} – {item.role}
              </h3>
              <span className="card-meta">
                {item.location} · {item.period}
              </span>
            </header>
            <div className="card-body">
              <p>{item.summary}</p>

              {/* Lista opcional de logros o participaciones */}
              {item.highlights && item.highlights.length > 0 && (
                <ul className="highlights">
                  {item.highlights.map((h, i) => (
                    <li key={i}>{h}</li>
                  ))}
                </ul>
              )}
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}


/* Si quieres montarlo de inmediato:
   <Resume data={resumeData} />
*/
